export enum TenantMediaTypeEnum {
  LOGO = 'logo',
  FAVICON = 'favicon'
}